// extracted by mini-css-extract-plugin
export default {"btn_classes":"button_btn_classes__VT65U","btn_classes_secondary":"button_btn_classes_secondary__D2J7t","disabled":"button_disabled__ftZGt"};